export const formats = [
  {
    value: "1",
    name: "MLA",
  },
  {
    value: "2",
    name: "APA",
  },
  {
    value: "3",
    name: "Chicago",
  },
  {
    value: "4",
    name: "Harvard",
  },
  {
    value: "5",
    name: "Other",
  },
];
